export default __webpack_public_path__ + "static/seo-acaef8546883738830e28a6fdf985049.jpg";